import { render, staticRenderFns } from "./myPlanDc.vue?vue&type=template&id=0fa4e052&scoped=true"
import script from "./myPlanDc.vue?vue&type=script&lang=js"
export * from "./myPlanDc.vue?vue&type=script&lang=js"
import style0 from "./myPlanDc.vue?vue&type=style&index=0&id=0fa4e052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa4e052",
  null
  
)

export default component.exports